var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-fade-transition',[_c('v-app',{directives:[{name:"show",rawName:"v-show",value:(_vm.store.ready),expression:"store.ready"}]},[_c('SystemBar'),_c('AppBar'),_c('NavigationDrawer'),_c('Content'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }